import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import {
  CategoryService,
  SubCategoryService,
  handleDeleteModal,
} from "../../Services";
import { Button, Modal, Spinner } from "react-bootstrap-v5";
import { MdEdit, MdOutlineDeleteForever, MdVisibility } from "react-icons/md";
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";
import { AddCategory } from "./AddCategory";
import { EditCategory } from "./EditCategory";
import Loader from "../../Components/Loader";
import { toast } from "react-toastify";
import CategoryDetail from "./CategoryDetail";
import ReactPaginate from "react-paginate";
import { useLocation } from 'react-router-dom'
import CheckAccess from "../../Function/CheckAccess";
let currentPage1 = 1;

export const CategoryList = () => {
  const history = useHistory();
  const [category, setCategory] = useState([]);
  const [addModal, setAddModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [editId, setEditId] = useState("");
  const [deleteId, setDeleteId] = useState("");
  const [loader, setLoader] = useState(false);
  const [viewid, setViewid] = useState("");
  const [catdetail, setCatdetail] = useState([]);
  const [catid, setCatid] = useState([]);
  const [asignsubcat, setAsignsubcat] = useState();
  const [subcatlist, setSubcatlist] = useState([]);
  const [subId, setSubId] = useState([]);
  const [catname, setCatname] = useState(false);
  const [asigncat, setAsigncat] = useState(false);
  const [subcatmodal, setSubcatmodal] = useState(false);
  const [subCategoryModal, setSubCategoryModal] = useState(false);
  const [pagination, setPagination] = useState({ page: 1, limit: 10 });
  const [currentPage, setCurrentPage] = useState(currentPage1);


  const location = useLocation()
  let user_type = localStorage.getItem("user_type")

  const getDetail = async () => {
    setLoader(true);
    let param = { ...pagination, page: currentPage };
    await CategoryService.getCategory(param).then((res) => {
      setLoader(false);
      setPagination({ ...pagination, ...res.pagination });
      setCategory(res.data);
    });
  };

  const getSubCat = async () => {
    await SubCategoryService.getSubCategory()
      .then((res) => {
        setSubcatlist(res?.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const subcat =
    subcatlist &&
    subcatlist.map((item, index) => {
      return {
        value: item._id,
        label: item.subcategory_name,
      };
    });

  const handleDelete = async () => {
    const obj = {
      id: deleteId,
    };
    await CategoryService.deleteCategory(obj).then((res) => {
      setLoader(true);
      if (res.status) {
        setLoader(false);
        getDetail();
        toast.success(res.message);
        setDeleteModal(false);
      } else {
        setLoader(false);
        toast.error(res.message);
      }
    });
  };

  const handleOpenEdit = (id) => {
    setEditId(id);
    setEditModal(true);
  };

  const handleDeleteModal = (id) => {
    setDeleteModal(true);
    setDeleteId(id);
  };

  const handleSubcategory = async (id) => {
    setViewid(id);
    setSubCategoryModal(true);
    let data = { id: id };
    await CategoryService.getSingalCategory(data)
      .then((res) => {
        let data = [];
        setCatname(res.data[0]?.category_name);
        setCatdetail(res?.data[0]?.sub_categories);
        for (let i = 0; i < res?.data[0]?.sub_categories.length; i++) {
          data.push({
            label: res?.data[0]?.sub_categories[i].subcategory_name,
            value: res?.data[0]?.sub_categories[i]._id,
          });
        }
        setSubId(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleSelect = (getvalue) => {
    let data = getvalue.map((e) => {
      return e.value;
    });

    setSubId(getvalue);
  };

  const submitSubcat = async () => {
    let subdata = subId.map((item) => item.value);
    let obj = {
      category_id: catid,
      subcategory_id: subdata,
    };

    CategoryService.asignSubcategort(obj)
      .then((res) => {
        if (res.status === true) {
          toast.success(res.message);
          setSubCategoryModal(false);
          setAsigncat(false);
        } else {
          toast.error(res.message);
        }
        // history.push("/category-list");
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const onPageChangeEvent = (e) => {
    currentPage1 = e.selected + 1
    setLoader(true);
    setCurrentPage(e.selected + 1);
  };

  useEffect(() => {
    getDetail();
    getSubCat();
  }, [currentPage]);

  return (
    <div style={{ width: "75%" }}>
      <div className="card">
        <div className="card-body">
          <div className="text-end mb-3">
          {
            (CheckAccess(61,"add") ||  user_type === "SUPERADMIN" )&& 
            <Button
              type="button"
              className="btn btn-primary"
              onClick={() => setAddModal(true)}
            >
              Add Category
            </Button>
          }
          </div>
          {/* {/ <div><Spinner animation="grow" size="sm"/></div>  /} */}

          <div className="table-responsive">
            <table className="table table-centered table-nowrap mb-0">
              <thead className="table-light">
                <tr>
                  <th>S no.</th>
                  <th> Name</th>
                  {/* {/ <th>Asign sub category</th> /} */}
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {category &&
                  category.length > 0 &&
                  category?.map((item, key) => (
                    <tr key={key}>
                      {/* <td className="text-body fw-bold">{key + 1}</td> */}
                      <td className="text-body fw-bold">{(pagination.page - 1) * pagination.limit + (key + 1)}</td>
                      
                      <td
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          handleSubcategory(item?._id);
                        }}
                      >
                        {item?.category_name || ""}
                      </td>

                      {/* <td>
                        <Button
                        style={{padding : "3px 8px"}}
                          type="button"
                          class="btn btn-primary"
                          onClick={() => {
                            setCatid(item?._id);
                            // setAsignsubcat(true);
                            setAsigncat(true)
                            handleSubcategory(item?._id);
                          }}
                        >
                          assign
                        </Button>
                      </td> */}

                      <td>
                        <MdVisibility
                          className="pointer"
                          // onClick={() => }
                          onClick={() => {
                            handleSubcategory(item?._id);
                            setSubCategoryModal(true);
                          }}
                          color="#0323fe"
                          size="25px"
                        />
                        {
                           (CheckAccess(61,"edit") || user_type === "SUPERADMIN") && 
                        <MdEdit
                          className="pointer"
                          onClick={() => handleOpenEdit(item?._id)}
                          style={{ fontSize: "22px", color: "rgb(3, 35, 254)" }}
                        />
                        }
                        {
                          (CheckAccess(61,"delete") ||  user_type === "SUPERADMIN") && 
                        <MdOutlineDeleteForever
                          className="pointer"
                          onClick={() => handleDeleteModal(item._id)}
                          style={{ fontSize: "22px", color: "red" }}
                        />
                        }


                        <Button
                          style={{ padding: "3px 8px" }}
                          type="button"
                          className="btn btn-primary"
                          onClick={() => {
                            setCatid(item?._id);
                            // setAsignsubcat(true);
                            setAsigncat(true);
                            handleSubcategory(item?._id);
                          }}
                        >
                          assign
                        </Button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
            <div className="text-center">
              {(loader && <Spinner animation="grow" size="sm" />) || ""}
            </div>
            {category?.length <= 0 && !loader && (
              <div className="text-center w-100 bg-warning my-5">
                <h6 className="py-2"> list not available </h6>
                {/* {/ <Spinner animation="grow" size="sm" /> /} */}
              </div>
            )}


            {category &&
              category.length > 0 &&
              pagination.total_record > pagination.limit && (
                <ReactPaginate
                  previousLabel={
                    <img
                      src="assets/images/prev.svg"
                      height={15}
                      alt="not found"
                    />
                  }
                  forcePage={currentPage - 1}
                  nextLabel={
                    <img
                      src="assets/images/next.svg"
                      height={15}
                      alt="not found"
                    />
                  }
                  breakLabel={"..."}
                  breakClassName={"break-me"}
                  pageCount={Math.ceil(
                    pagination.total_record / pagination.limit
                  )}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={3}
                  onPageChange={(e) => onPageChangeEvent(e)}
                  containerClassName={"pagination"}
                  activeClassName={"active"}
                />
              )}
          </div>

          {/* {/ Add Modal /} */}

          <Modal
            show={addModal}
            onHide={() => setAddModal(false)}
            animation={false}
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>Add Category</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <AddCategory setAddModal={setAddModal} getDetail={getDetail} />
            </Modal.Body>
          </Modal>

          {/* {/ Edit Modal /} */}

          <Modal
            show={editModal}
            onHide={() => setEditModal(false)}
            animation={false}
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>Edit Category</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <EditCategory
                setEditModal={setEditModal}
                editId={editId}
                getDetail={getDetail}
              />
            </Modal.Body>
          </Modal>

          {/* {/ Delete Modal /} */}

          <Modal
            show={deleteModal}
            onHide={() => setDeleteModal(false)}
            animation={false}
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>Delete Category</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <h6>Are you sure want to delete category</h6>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="success" onClick={() => setDeleteModal(false)}>
                Close
              </Button>
              <Button variant="danger" onClick={handleDelete}>
                {(loader && <Spinner animation="grow" size="sm" />) || "Delete"}
              </Button>
            </Modal.Footer>
          </Modal>

          {!asigncat ? (
            <Modal
              show={subCategoryModal}
              onHide={() => setSubCategoryModal(false)}
              // animation={false}
              centered
            >
              <Modal.Header closeButton>
                <Modal.Title>{catname}</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <CategoryDetail
                  catdetail={catdetail}
                  viewid={viewid}
                  handleSubcategory={handleSubcategory}
                  setSubcatmodal={setSubcatmodal}
                  catname={catname}
                />
              </Modal.Body>
            </Modal>
          ) : (
            ""
          )}

          <Modal
            show={asigncat}
            onHide={() => setAsigncat(false)}
            // animation={false}
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>Assign Sub Category</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <ReactMultiSelectCheckboxes
                className="Volumeselect form-control"
                options={subcat}
                onChange={handleSelect}
                value={subId}
              />
            </Modal.Body>
            <Modal.Footer>
              <Button
                style={{ zIndex: 9 }}
                type="button"
                onClick={submitSubcat}
              >
                Submit
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    </div>
  );
};
